// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import DynamicContentLoader from "./components/DynamicContentLoader";

const AppContent = () => (
  <Routes>
    <Route path="/" element={<DynamicContentLoader />} />
  </Routes>
);

const App = () => (
  <Router>
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  </Router>
);

export default App;
